import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/Users/erwannletue/Dev/dearfox/genesis/layouts/admin.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/Users/erwannletue/Dev/dearfox/genesis/layouts/auth.vue").then(m => m.default || m)),
  card: defineAsyncComponent(() => import("/Users/erwannletue/Dev/dearfox/genesis/layouts/card.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/erwannletue/Dev/dearfox/genesis/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/Users/erwannletue/Dev/dearfox/genesis/layouts/empty.vue").then(m => m.default || m))
}